/* eslint-disable no-restricted-imports */
import { Divider, Stack } from '@mui/material';
import React, { FC } from 'react';
import { OrderItemListRows } from '@/data/Content/OrderItemList';
import { OrderHistoryDetailsProduct } from '../OrderHistoryDetailsProduct';

export const OrderHistoryDetailsProducts: FC<{
	items: OrderItemListRows;
}> = ({ items }) => (
	<Stack direction="column">
		{items.map((item, index) => (
			<React.Fragment
				key={item.orderItemListRow.itemDetails.orderItemId || `${item.details.partNumber}-${index}`}
			>
				<Divider sx={{ marginTop: 2, marginBottom: 2 }} />
				<OrderHistoryDetailsProduct item={item} />
			</React.Fragment>
		))}
	</Stack>
);
